import { useCallback, useEffect, useRef } from "react";

/**
 * Prevents API hydration effects from overwriting in-progress user input.
 * Reset when entityId changes (e.g. different event).
 */
export function useFormHydrationGuard(entityId) {
  const userHasEditedRef = useRef(false);
  const hydratedIdRef = useRef(null);

  useEffect(() => {
    userHasEditedRef.current = false;
    hydratedIdRef.current = null;
  }, [entityId]);

  const markEdited = useCallback(() => {
    userHasEditedRef.current = true;
  }, []);

  const shouldBlockHydration = useCallback(
    (id = entityId) => userHasEditedRef.current || hydratedIdRef.current === id,
    [entityId]
  );

  const markHydrated = useCallback(
    (id = entityId) => {
      hydratedIdRef.current = id ?? null;
    },
    [entityId]
  );

  const resetHydration = useCallback(() => {
    userHasEditedRef.current = false;
    hydratedIdRef.current = null;
  }, []);

  return {
    markEdited,
    shouldBlockHydration,
    markHydrated,
    resetHydration,
    userHasEditedRef,
    hydratedIdRef,
  };
}
